export default {
  name: "OkayDialog",
  props: {
    showDialog: {
      default: false,
      type: Boolean,
    },
    text: {
      required: true,
      type: String,
    },
  },

  watch: {
    showDialog() {
      this.dialog = true;
    },
  },

  data: () => ({
    dialog: true,
  }),

  methods: {
    confirmAction() {
      this.$emit("confirmAction");
      this.dialog = false;
    },
  },
};
